<template>
    <div id="Authentication">
        <Nav />
        <div class="main">
            <el-form label-width="130px" :model="authFrom" ref="authFrom" :rules="rules" style="margin-top:40px;">
                    <p class="title_info">认证信息</p>
                    <el-form-item label="账号头像" prop="logo" >
                        <Uploader :id="logo" :url.sync="authFrom.logo"  :size="2" :w="300" :h="300" :status="true" :maxImgSize="300" media-type="image"/>
                    </el-form-item>
                    <el-form-item  label="账号名称" prop="auth_name">
                        <el-input v-model="authFrom.auth_name" placeholder="请填写账号名称（ 2 到 10 个字，需与机构有关）"/>
                    </el-form-item>
                    <el-form-item  label="认证说明" prop="auth_info">
                        <el-input v-model="authFrom.auth_info" placeholder="例：行业领头羊（限 5 - 20 字）"/>
                    </el-form-item>
                    <el-form-item  label="账号介绍" prop="intro">
                        <el-input type="textarea" v-model="authFrom.intro" maxlength="60" minlength="5" placeholder="简要介绍账号相关服务（长度在 5 到 60 个字）"/>
                    </el-form-item>
                    <p class="title_info">机构信息</p>
                    <el-form-item  label="机构名称" prop="company_name">
                        <el-input v-model="authFrom.company_name" placeholder="请与营业执照保持一致"/>
                    </el-form-item>
                    <el-form-item label="营业执照" prop="company_register_image" >
                        <Uploader :id="register" :url.sync="authFrom.company_register_image" :size="2" :clip="false" :intro="registerIntro" media-type="image"/>
                    </el-form-item>
                    <el-form-item label="确认公函" prop="official_letter_image" >
                        <Uploader :id="letter" :url.sync="authFrom.official_letter_image" :size="2" :clip="false"  :letter="letterIntro" media-type="image"/>
                    </el-form-item>
                    <p class="title_info">运营者信息</p>
                    <el-form-item label="运营者姓名" prop="operator_name" >
                        <el-input v-model="authFrom.operator_name" placeholder="请输入运营者身份证姓名保持一致"/>
                    </el-form-item> 
                    <el-form-item label="运营者身份证" prop="operator_id_card_image" >
                        <Uploader :id="card" :url.sync="authFrom.operator_id_card_image" :size="2"  :clip="false" :intro="id_card" :cardShow="true" media-type="image"/>
                    </el-form-item>
                    <el-form-item label="邮箱" prop="operator_email" >
                        <el-input  v-model="authFrom.operator_email" placeholder="请输入邮箱"/>
                    </el-form-item>
                    <el-form-item>
                        <!-- <el-row>
                            <el-col> -->
                                <el-checkbox v-model="userAgreement" style="float:left"></el-checkbox>
                            <!-- </el-col>
                            <el-col> -->
                                <p class="userAgreement">请同意<a @click="toUserAgreement">《微解药用户注册协议》</a></p>
                            <!-- </el-col>
                        </el-row> -->
                    </el-form-item>
                    <el-form-item>
                        <!-- <el-tooltip v-model="userAgreement" class="item" effect="light" content="请选择微解用户注册协议" placement="right"> -->
                            <el-button type="primary" :disabled="!userAgreement" style="width:100px;margin-left:40%; background-color:#00b1b4; border-color:#fff" @click="subminForm">提交</el-button>
                        <!-- </el-tooltip>  -->
                    </el-form-item>
            </el-form>
        </div>
       <div id="userAgreement" class="modal fade bs-example-modal-lg" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                    <h4 class="modal-title" id="myModalLabel" style="text-align: center">微解药用户注册协议</h4>
                </div>
                <Useprotocol/>
            </div>
        </div>
        </div>
    </div>
</template>

<script>
import Nav from '@/components/common/nav'
import Uploader from '@/components/common/upload'
import Useprotocol from '@/components/Useprotocol'
import { toAuth, toRetAuth, getInfo, getUserInfo } from '@/api/auth'
import { getUid } from '@/utils'

export default {
    name: "Authentication",
    components: {
        Nav,
        Uploader,
        Useprotocol,
    },
    data(){
        return{
            userAgreement: false,
            logo:'logo',
            card:'card',
            letter:'letter',
            register: 'register',
            registerIntro:'企业营业执照信息清晰，',
            letterIntro:'请点击下载<a href="http://weijieyao.com/download/gonghan.docx"  target="_Blank">确认公函</a>，填写后上传，确认公函信息清晰',
            id_card:'请参考样例，',
            authFrom: {
                logo:'',
                auth_name: '',
                operator_email: '',
                operator_id_card_image:'',
                official_letter_image: '',
                company_register_image: '',
                company_name: '',
                operator_name: '',
                auth_info: '',
                intro: '',
            },
            companyData: {},
            rules:{
                operator_email: [
                    {type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
                ],
                operator_id_card_image: {
                    required: true, message: '请上传图片', trigger: 'change'
                },
                official_letter_image: {
                    required: true, message: '请上传图片', trigger: 'change'
                },
                company_register_image: {
                    required: true, message: '请上传图片', trigger: 'change'
                },
                company_name: {
                    required: true, message: '请输入营业执照名称', trigger: 'blur'
                },
                auth_name: [
                    { required: true, message: '请输入账号名称', trigger: 'blur' },
                    { min: 2, max: 10, message: '长度在 2 到 10 个字', trigger: 'blur' }
                ],
                operator_name: [
                    { required: true, message: '请输入运营者姓名', trigger: 'blur' }
                ],
                logo: {
                    required: true, message: '请上传图片', trigger: 'change'
                },
                auth_info:[{
                    required: true, message: '请输入主体说明', trigger: 'change,blur'
                },
                { min: 5, max: 20, message: '长度在 5 到 20 个字', trigger: 'blur' }
                ],
                intro:[ {
                    required: true, message: '请输入账号介绍', trigger: 'change,blur'
                },
                { min: 5, max: 60, message: '长度在 5 到 60 个字', trigger: 'blur' }
                ]
           }
        }
    },
    methods: {
        toUserAgreement() {
            $('#userAgreement').modal('show')
        },
        async fetchData() {
            this.companyData = this.$route.params
            const Uid = getUid()
            if(this.companyData.company_auth_status === 'unsubmitted') {
                this.$refs.authFrom.resetFields()
            } else if(this.companyData.auth_status){
                this.authFrom= this.companyData
            }else {
                if (Uid) {
                    const { data } = await getUserInfo(Uid)
                    this.params = {
                        'operator_mobile':data.data.company_user.mobile
                    }
                    const authData = await getInfo(this.params)
                    this.authFrom = authData.data.data.auth
                }
            }
        },
        // 提交
        subminForm() {
            this.$refs.authFrom.validate(async valid => {
                if (!valid) {
                    return
                }
                await this.$confirm('确定保存？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                })
                const { _id, ...fromData }  = this.authFrom
                const userId = getUid()
                fromData.operator_mobile = this.companyData.company_auth_status === 'unsubmitted' ?
                 this.companyData.mobile : this.companyData.operator_mobile
                fromData.company_user_id = userId
                const { data } = this.companyData.company_auth_status === 'unsubmitted' ? 
                await toAuth(fromData) : await toRetAuth({'id': _id, ...fromData})
                this.$router.push({
                    name:'Authstatus',
                    params: data.data.auth,
                })
                // this.$message.success(msg)
            })
        }
    },
    mounted(){
        document.getElementsByClassName('navbar-inverse')[0].setAttribute('style','position:relative')
        this.fetchData()
    }
}
</script>

<style scoped lang="scss" >
#Authentication  #navs{
    background: #000;
    position:inherit;
}
.userAgreement{
    font-size: 12px; 
    float: left;
    margin-left: 5px;
    a{
        cursor: pointer;
    }
}
.main{
    width: 80%;
    margin:20px auto;
    padding:20px;
    padding-right: 40px;
    border: rgb(224, 224, 224);
    box-shadow: rgb(170, 170, 170) 1px 0px 20px 2px;
}
.text{
    font-size: 12px;
    color:#666;
    line-height: 30px;
}
.title_info{
    width:100%;
    height:40xp;
    border-left:8px solid #00b1b4;
    padding-left:20px;
    font-size: 16px;
    font-weight: bold;
    margin:40px;
}
</style>


// WEBPACK FOOTER //
// src/components/Authentication.vue